<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title">The Roderick Alleyn Mysteries Volume 3</p>
<h2 class="center" style="margin-top:20px;">Death in a White Tie, Overture to Death, Death at the Bar</h2>
<p class="authorname">Ngaio Marsh</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_title.vue?76672fab